import { FULL_NAME, MAIL, PHONE } from "Constant";
import { civilityObj, createdAt, updatedAt } from "Constant/objs";
import { z } from "zod";
import { getCodeLabel } from "helper/getOptions";

export const API = {
  list: "/front/drivers?index=-1",
  create: "/front/driver",
  get: "/front/driver/",
  edit: "/front/driver/",
};

// Columns
export const COLUMNS = [
  {
    name: FULL_NAME,
    selector: "completename",
  },
  {
    name: PHONE,
    selector: "phone",
  },
  {
    name: MAIL,
    selector: "mail",
  },

  createdAt,
  updatedAt,

  // {
  //   body: (data) => {
  //     console.log(data);
  //     const image = data.image ?? driver;

  //     return <Avatar image={image} size="xlarge" shape="circle" />;
  //   },
  //   name: "img",
  // },
];

// Form
export const CREATE_TAXI_DRIVER = [
  civilityObj,
  {
    title: "First name",
    placeholder: "First name",
    name: "firstname",
    inputForm: "SimpleInput",
    schema: z.string().min(3, "Ce champ est obligatoire"),
  },
  {
    title: "Last name",
    placeholder: "Last name",
    name: "lastname",
    inputForm: "SimpleInput",
  },
  {
    title: "Phone",
    placeholder: "Phone",
    name: "phone",
    inputForm: "SimpleInput",
    schema: z.string().min(8, {
      message: "Le numéro de téléphone doit comporter au moins 8 chiffres.",
    }),
  },

  // {
  //   title: "Mail",
  //   placeholder: "Mail",
  //   name: "mail",
  //   inputForm: "SimpleInput",
  //   // schema: z.string().email(),
  //   required: false,
  // },

 {
    title: "Address",
    placeholder: "Address",
     name: "address",
    inputForm: "SimpleInput",
     required: false,
  },

  {
    title: "Licence",
    placeholder: "licence",
    name: "licence",
    inputForm: "SimpleInput",
  },
  {
    title: "Licence got at",
    placeholder: "licencegotat",
    name: "licenceGotAt",
    inputForm: "DateInput",
  },
  {
    title: "Licence Expire At",
    placeholder: "licenceExpireAt",
    name: "licenceExpireAt",
    inputForm: "DateInput",
  },
  {
    title: "Taxi",
    name: "taxi",
    inputForm: "SelectApiInput",
    optionsApi: `/front/taxisChoices`,
    getOptions: getCodeLabel,
    required: false, 
    schema: z.string().nullable().optional(), 
     disabledWhen: "inAllTaxi"
  },
  {
    title: "Accès à tous les taxis",
    name: "inAllTaxi",
    inputForm: "CheckBox",
    required: false,
    schema: z.boolean().nullable().optional().default(false),
  }
];
